
'use strict';

var routes = require('./routes');
var app = {};

app.getId = function() {
	return '__svtse';
};

app.getRoutes = function() {
	return routes;
};

module.exports = app;



/** WEBPACK FOOTER **
 ** ./app/index.js
 **/